import type { CompanyId } from "@repo/app-types/entities/company";
import { parseServiceAccessOrigin } from "@repo/app-types/entities/serviceAccess";

const serviceAccessDomain = import.meta.env.VITE_APP_SERVICE_ACCESS_DOMAIN;

/**
 * The company whose service access origin this tab is on, or null outside
 * service mode. The hostname decides only which client runs; the UI branches
 * on `/user`'s `session.type`. Besides the configured domain's origin, a dev
 * server on `<company-id>.customers.localhost`, on any port, is one too, so a
 * dev server against production works from any worktree.
 */
export const serviceAccessCompanyId: CompanyId | null = serviceAccessDomain
  ? parseServiceAccessOrigin(serviceAccessDomain, window.location.origin)
  : null;

/** Whether this tab is on a company's service access origin. */
export function checkIsServiceMode() {
  return serviceAccessCompanyId !== null;
}
